import React from 'react';
import Button from '@atlaskit/button/standard-button';
import MoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--more';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { useIntl } from '@atlassian/jira-intl';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { IssuesMoreButton as MoreButtonInner, Props } from './index.tsx';
import messages from './messages.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const MoreButtonLazy = lazy<typeof MoreButtonInner>(() =>
	import(
		/* webpackChunkName: "async-jira-software-releases-version-detail-issue-list" */ './index'
	).then((mod) => mod.IssuesMoreButton),
);

export const IssuesMoreButton = (props: Props) => {
	const { formatMessage } = useIntl();
	return (
		<JSErrorBoundary
			fallback="flag"
			id="jira.software.releases.version.detail.issue.list.more.button"
			packageName="jira-software-releases-version-detail-issue-list"
			teamName="nova"
		>
			<Placeholder
				name="jira-software-releases-version-detail-issue-list"
				fallback={
					<Button
						appearance="subtle"
						iconBefore={
							<MoreIcon spacing="spacious" label={formatMessage(messages.moreButtonLabel)} />
						}
					/>
				}
			>
				<MoreButtonLazy {...props} />
			</Placeholder>
		</JSErrorBoundary>
	);
};
